import { v1ApiClient } from '@/services';
import type { PathParams, RequestBody, ResponseBody } from '@/shared/api/generated';

type PromptLibrariesPath = '/v1/workspaces/{workspace_id}/prompt-libraries';

export type CreateHeySynclyPromptLibraryParams =
  PathParams<PromptLibrariesPath, 'post'> &
    RequestBody<PromptLibrariesPath, 'post'>;
export type CreateHeySynclyPromptLibraryResponse = ResponseBody<
  PromptLibrariesPath,
  'post'
>;

export const createHeySynclyPromptLibrary = ({
  workspace_id,
  ...body
}: CreateHeySynclyPromptLibraryParams): Promise<CreateHeySynclyPromptLibraryResponse> =>
  v1ApiClient
    .post(`/workspaces/${workspace_id}/prompt-libraries`, body)
    .then((res) => res.data);
